export default "__VITE_ASSET__BtdGvubD__"